<template>
  <div style="width: 100%; height: 100%; position: relative">
    <h2 style="text-align: center; padding-top: 20px">项目拖拽排序</h2>
    <div>
      <el-button
        style="margin: 0 0 20px 30px"
        type="primary"
        @click="addProject()"
        >新增项目</el-button
      >
    </div>
    <!-- 弹框 -->
    <el-dialog
      title="创建项目"
      :visible.sync="centerDialogVisible"
      width="60%"
      center
      style="font-size: 20px"
    >
      <div class="xianshikuang">
        <span class="lableName"> 中文名称：</span>
        <el-input placeholder="请输入项目中文名称" v-model="project_name_cn">
        </el-input>
      </div>
      <div class="xianshikuang">
        <span class="lableName"> 英文名称：</span>
        <el-input placeholder="请输入项目英文名称" v-model="project_name_en">
        </el-input>
      </div>
      <div class="xianshikuang">
        <span class="lableName"> 项目ID：</span>
        <el-input placeholder="请输入项目ID" v-model="projectID"> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="queding">确 定</el-button>
      </span>
    </el-dialog>

    <el-table
      :data="xiangmuList"
      row-key="project_id"
      align="left"
      :row-style="{ height: '44px' }"
      :cell-style="{ padding: '0 4px' }"
      height="78%"
      :header-cell-style="{ background: 'rgb(100, 168, 165)', color: '#fff' }"
    >
      <el-table-column
        prop="project_name_en"
        label="项目英文"
      ></el-table-column>
      <el-table-column prop="project_name_cn" label="项目"></el-table-column>
      <el-table-column
        prop="project_company_id"
        label="项目ID"
      ></el-table-column>

      <el-table-column prop="project_company_id" label="项目管理人" width="380">
        <template slot-scope="scope">
          <div style="display: flex" class="gai">
            <el-tag
              style="margin-right: 10px"
              :key="index"
              v-for="(tag, index) in scope.row.managers"
              closable
              :disable-transitions="false"
              @close="handleClose(tag, scope.row)"
            >
              {{ tag.employee_name_abbr }}
            </el-tag>

            <div>
              <el-input
                style="position: relative; display: block; width: 90px"
                class="input-new-tag"
                v-if="scope.row.edit"
                v-model="scope.row.zhanShi"
                :ref="'input' + scope.row.employee_id"
                size="small"
                @keyup.native="getHintsList(scope.row, $event)"
                @blur="shiqu(scope.row)"
              >
              </el-input>
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput(scope.row)"
                >+</el-button
              >

              <div
                class="hintsBox"
                v-if="scope.row.showHintsBox"
                :style="styleObject"
                ref="tanBox"
                @scroll="gunDong()"
              >
                <ul
                  class="hintslist"
                  @mouseover="mouseOver"
                  @mouseleave="mouseLeave"
                >
                  <li
                    v-for="(item, index2) in scope.row.hints"
                    :key="index2"
                    class="hint"
                    :class="item == selected ? 'selected' : ''"
                    @click="fillInput(index2, scope.row)"
                  >
                    {{ item.employee_name_abbr }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="all_payed"
        label="是否完结"
        :formatter="cnName"
      ></el-table-column>
    </el-table>
  </div>
</template>
<style scoped>
.lableName {
  width: 15%;
  line-height: 40px;
}
.xianshikuang {
  display: flex;
  padding: 10px;
}
.gai >>> .el-tag {
  padding: 0 8px;
}
.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 80px;
  vertical-align: bottom;
}
[v-cloak] {
  display: none;
}

.hintsbox-mark {
  position: relative;
}

.hintsbox-mark input {
  width: 250px;
}

.hintsBox {
  position: absolute;
  z-index: 100000;
  /* top:264px;
  left:538px; */
  width: 120px;
  border: 1px solid #ddd;
  border-radius: 5%;
  background-color: skyblue;
  max-height: 200px;
  overflow-y: scroll;
}

/*滚动条样式*/
.hintsBox::-webkit-scrollbar {
  width: 1px;
  height: 4px;
}
.hintsBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.hintsBox::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.hintslist .hint {
  padding: 4px 4px;
}

.hintslist .hint:hover {
  background-color: #ddd8e5;
  cursor: pointer;
}

.hintslist .hint.active {
  background-color: #ddd8e5;
}
.selected {
  background-color: #ddd8e5 !important;
}
</style>
<script>
import Sortable from "sortablejs";
import axios from "axios";
import { getBaseInfo } from "@/api/user";
export default {
  data() {
    return {
      xiangmuList: [],
      dynamicTags: ["标签一", "标签二"],
      inputVisible: false,
      inputValue: "",
      activeNo: -1,
      employeeDeparts: [],
      selected: "",
      getShijiao: "",
      inputY: "",
      inputliTop: "",
      styleObject: {},
      centerDialogVisible: false,
      projectID: "",
      project_name_cn: "",
      project_name_en: "",
    };
  },
  mounted() {
    this.getEmployee_depart();
    this.getPorjectList();
    this.rowDrop();
  },
  methods: {
    //确定按钮
    queding() {
      if (
        this.project_name_cn != "" &&
        this.project_name_en != "" &&
        this.projectID != ""
      ) {
        axios
          .post(IPConfig.IP + "/kpi-management/project/create_project.php", {
            project_company_id: this.projectID,
            project_name_en: this.project_name_en,
            project_name_cn: this.project_name_cn,
          })
          .then((res) => {
            console.log(res);
            if (res.data.errcode == 0) {
              this.getPorjectList();
              this.centerDialogVisible = false;
              this.$message({
                message: "项目创建成功",
                type: "success",
                duration: 1000,
              });
            }
            if (res.data.errcode == 4001) {
              let msg = res.data.errmsg;
              this.$message({
                message: msg,
                type: "error",
                duration: 1000,
              });
            }
          });
      } else {
        this.$message({
          message: "请填写完所有的信息",
          type: "error",
          duration: 1000,
        });
      }
    },
    addProject() {
      // this.xzperson = []; //选中有权限的人
      // this.hqproject = ""; //项目为空
      this.centerDialogVisible = true; //弹框
      // this.flag = 1;
    },
    //判断滚动条的高度
    gunDong(el) {
      //console.log(this.$refs.tanBox.scrollTop);
      if (el) {
        this.$refs.tanBox.scrollTop = el;
      }
    },
    mouseOver() {
      //console.log(111);
      //判断是否在选则框内
      this.getShijiao = 1;
    },
    mouseLeave() {
      //console.log(222);
      this.getShijiao = "";
    },
    getEmployee_depart() {
      return new Promise((resolve, reject) => {
        axios
          .post(IPConfig.IP + "/kpi-management/info/employee_departs.php", {})
          .then((res) => {
            //console.log(res.data.employee_departs);
            let employee_departs = res.data.employee_departs;
            for (let i in employee_departs) {
              employee_departs[i].employee_name_abbr =
                employee_departs[i]["employee_name"] +
                "-" +
                employee_departs[i]["depart_abbr"];
            }
            //console.log(employee_departs);
            this.employeeDeparts = employee_departs;
          });
      });
    },
    //当鼠标取消时
    shiqu(row) {
      console.log(row.zhanShi);
      if (this.getShijiao == "") {
        if (typeof row.zhanShi == "undefined" || row.zhanShi == "") {
          row.edit = false;
          row.zhanShi = "";
          row.showHintsBox = false;
          this.$forceUpdate();
        } else {
          this.sureSubmit(row);
        }
      }
    },

    //获取候选列表
    getHintsList(row, $event) {
      console.log($event);
      console.log("发起查询请求");
      console.log(this.employeeDeparts);
      console.log(row);
      console.log(row.zhanShi);

      //按Enter键
      if ($event.keyCode == 13) {
        this.sureSubmit(row);
      } //Down键事件
      if ($event.keyCode == 40) {
        //划到最后一项的时候
        if (row.hints) {
          console.log(row.hints);
          let len = row.hints.length;
          if (len <= 0) {
            return;
          } else {
            this.activeNo += 1;
            console.log(this.activeNo);
            console.log(len);
            console.log(this.$refs.tanBox.scrollTop);
            // let shuzhi = 30;
            if (this.activeNo >= 6) {
              this.$refs.tanBox.scrollTop += 30;
              // this.gunDong(this.$refs.tanBox.scrollTop);
              // if(this.$refs.tanBox.scrollTop > 143){
              //   this.$refs.tanBox.scrollTop = 0;
              // }
            }

            if (this.activeNo > len - 1) {
              console.log("到底了");
              this.activeNo = 0;
              this.$refs.tanBox.scrollTop = 0;
              this.gunDong(this.$refs.tanBox.scrollTop);
              //console.log(row.hints[this.activeNo]);
              //return;
            }
            //console.log(this.activeNo);
            this.selected = row.hints[this.activeNo];
            row.inputValue = row.hints[this.activeNo].employee_id;
            row.zhanShi = row.hints[this.activeNo].employee_name_abbr;
            //console.log(row.hints[this.activeNo]);

            this.$forceUpdate();
          }
          console.log("向下事件");
        }
        return;
      }
      //Up键事件
      if ($event.keyCode == 38) {
        if (row.hints) {
          console.log(row.hints);
          let len = row.hints.length;
          if (len <= 0) {
            return;
          } else {
            this.activeNo -= 1;
            console.log(this.activeNo);
            console.log(len);
            if (this.activeNo < 0) {
              console.log("到顶了");
              this.activeNo = len - 1;
              this.$refs.tanBox.scrollTop = 143;
            } else {
              this.$refs.tanBox.scrollTop -= 30;
            }
            //console.log(this.activeNo);

            this.gunDong(this.$refs.tanBox.scrollTop);
            this.selected = row.hints[this.activeNo];
            row.inputValue = row.hints[this.activeNo].employee_id;
            row.zhanShi = row.hints[this.activeNo].employee_name_abbr;
            //console.log(row.hints[this.activeNo]);
            this.$forceUpdate();

            // this.selected =
            // row.inputValue = "";
          }
          console.log("向上事件");
        }
        return;
      } else {
        if (row.zhanShi != "") {
          var getpersonList = [];

          for (let i in this.employeeDeparts) {
            if (
              this.employeeDeparts[i]["employee_name"].indexOf(row.zhanShi) !=
              -1
            ) {
              let obj = {};
              obj.employee_id = this.employeeDeparts[i]["employee_id"];
              obj.employee_name = this.employeeDeparts[i]["employee_name"];
              var name_depart =
                this.employeeDeparts[i]["employee_name"] +
                "-" +
                this.employeeDeparts[i]["depart_abbr"];
              obj.employee_name_abbr = name_depart;
              //console.log(this.employeeDeparts[i].employee_name);
              getpersonList.push(obj);
            }
          }
          //var arr = ["选项1", "选项2", "选项3", "选项4", "haha"]; //模拟后台返回的数据
          console.log(getpersonList);

          row.showHintsBox = true;
          if (this.inputY - this.inputliTop <= 280) {
            console.log("该朝上了");
            this.styleObject.bottom = 45 + "px";
          } else {
            this.styleObject = {};
          }
          row.hints = getpersonList;
          this.$forceUpdate();
        } else {
          this.$nextTick(() => {
            this.$forceUpdate();
            row.showHintsBox = false;
            row.hints = [];
          });
        }
      }
    },

    sureSubmit(row) {
      console.log(row);
      console.log(this.employeeDeparts);
      var nameArr = [];
      for (let i in this.employeeDeparts) {
        if (
          this.employeeDeparts[i]["employee_name_abbr"] == row.zhanShi ||
          this.employeeDeparts[i]["employee_name"] == row.zhanShi
        ) {
          console.log(this.employeeDeparts[i].employee_id);
          let obj = {};
          obj.id = this.employeeDeparts[i].employee_id;
          obj.employee_name_abbr = this.employeeDeparts[i].employee_name_abbr;
          nameArr.push(obj);
        }
      }
      console.log(nameArr.length);
      if (nameArr.length > 0) {
        console.log(row.inputValue);
        if (typeof row.inputValue == "undefined" || row.inputValue == "") {
          row.inputValue = nameArr[0].id;
          row.zhanShi = nameArr[0].employee_name_abbr;
        }
        this.handleInputConfirm(row);
      } else {
        this.$message({
          message: "这名员工不存在",
          type: "error",
          duration: 1000,
        });
        row.edit = false;
        row.inputValue = "";
        row.zhanShi = "";
        row.showHintsBox = false;
      }
      this.activeNo = -1;
      this.selected = "";
      this.$forceUpdate();
    },

    //依据hints数组下标值填充输入框
    fillInput(index, row) {
      console.log(index);
      console.log(row);
      row.inputValue = row.hints[index].employee_id;
      row.zhanShi = row.hints[index].employee_name_abbr;
      this.handleInputConfirm(row);
    },
    handleInputConfirm(row) {
      console.log(row.project_id);
      console.log(row.inputValue);
      console.log(row.managers);
      row.hints = [];
      row.showHintsBox = false;

      let inputValue = row.inputValue;

      if (inputValue) {
        let getObj = {};
        getObj.employee_id = row.inputValue;
        getObj.employee_name_abbr = row.zhanShi;
        row.managers.push(getObj);
        axios
          .post(
            IPConfig.IP + "/kpi-management/mgmt/project/add_project_auth.php",
            {
              employee_id: row.inputValue,
              project_id: row.project_id,
            }
          )
          .then((res) => {
            console.log(res);
            // this.getPorjectList();
          });
      }
      row.edit = false;
      row.inputValue = "";
      row.zhanShi = "";
      this.activeNo = -1;
      this.selected = "";
      this.$forceUpdate();
    },

    handleClose(tag, row) {
      axios
        .post(
          IPConfig.IP + "/kpi-management/mgmt/project/del_project_auth.php",
          {
            employee_id: tag.employee_id,
            project_id: row.project_id,
          }
        )
        .then((res) => {
          console.log(res);
          // this.getPorjectList();
        });

      row.managers.splice(row.managers.indexOf(tag), 1);
    },

    showInput(row) {
      console.log(row);
      this.$set(row, "edit", true);
      // this.inputVisible = true;
      this.$nextTick((_) => {
        row.edit = true;
        var zhiInput = "input" + row.employee_id;
        // console.log(zhiInput);
        this.$refs[zhiInput].$refs.input.focus();
        this.inputliTop =
          this.$refs[zhiInput].$refs.input.getBoundingClientRect().bottom;
        this.inputY = document.body.clientHeight;
        // console.log(this.$refs[zhiInput].$refs.input.getBoundingClientRect().bottom)
        // console.log( document.body.clientWidth);
        // console.log( document.body.clientHeight);
      });
    },

    //确认提交赋值

    // doubleClickCell(row, column, cell, event) {
    //   console.log(row, column);
    //   if (column.property == "project_company_id") {
    //     this.$set(row, "seen", true);
    //     this.$nextTick(() => {
    //       this.$refs["mark"].focus();
    //     });
    //     // row.seen = true;
    //   }
    // },

    cnName(row, column) {
      //console.log(row.employee_id);
      if (row.all_payed == 0) {
        //console.log(this.getdataxm);
        return "未完结";
      } else {
        return "已完结";
      }
      // return row.address;
    },
    //获取项目列表数据
    getPorjectList() {
      getBaseInfo().then((data) => {
        //console.log(data);
        var porjectList = data.project_list;
        //console.log(porjectList);
        //获取的数据是对象，这里要把对象转成数组
        //console.log(this.xiangmuList);

        //var obj = porjectList; //定义对象（data为获取到的对象，在这里定义）
        var arr = Object.values(porjectList); //对象转化为数组
        //console.log(arr);

        arr.sort(function (a, b) {
          return a.order_id - b.order_id;
        });

        this.xiangmuList = arr;
        console.log(this.xiangmuList);
        // for (let key in porjectList) {
        //   this.xiangmuList.push(porjectList[key]);
        //   //this.porjectList[porjectList[key]["order_id"]] = porjectList[key];
        // }

        
      });
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      //console.log("tbody", tbody);
      tbody.style.background = "red";
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.xiangmuList.splice(oldIndex, 1)[0];
          _this.xiangmuList.splice(newIndex, 0, currRow);
          var gaiporjectList = [];
          //console.log(_this.porjectList);
          for (let key in _this.xiangmuList) {
            //console.log(_this.porjectList[key].project_id)
            gaiporjectList.push(_this.xiangmuList[key].project_id);
          }
          //console.log(gaiporjectList);

          //project_id_list":[1,2,3,4,5,6]
          axios
            .post(
              IPConfig.IP + "/kpi-management/project/update_project_order.php",
              //   JSON.stringify(gaiporjectList)
              { project_id_list: gaiporjectList }
            )
            .then((res) => {
              console.log(res);
              //   this.inputValue = "";
              //   this.getTodoList();
            });
        },
      });
    },
    //列拖拽
    columnDrop() {
      const wrapperTr = document.querySelector(".el-table__header-wrapper tr");
      console.log("wrapperTr", wrapperTr);
      this.sortable = Sortable.create(wrapperTr, {
        animation: 180,
        delay: 0,
        onEnd: (evt) => {
          const oldItem = this.dropCol[evt.oldIndex];
          this.dropCol.splice(evt.oldIndex, 1);
          this.dropCol.splice(evt.newIndex, 0, oldItem);
        },
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/tuozhuai.vue